import { TranslationStatusModel } from "./translation-status.model";
import { TransmissionMetadatas } from "./transmission-metadatas.model";

export class EmissionMetadatas extends TransmissionMetadatas {
  federations: TranslationStatusModel[];

  constructor(data: any) {
    super(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/metadata/emission-metadatas.model.ts